<div>
  <div class="row">
    <div class="col-md-8 m-auto">
      <div class="text-center mt-4" v-if="!isMobileView">
        <button
          type="button"
          class="btn btn-primary text-white"
          @click.prevent="PrintReport"
        >
          حفظ الوثيقة
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-8 m-auto">
      <div class="text-left my-4" v-if="isMobileView">
        <button
          type="button"
          class="btn btn-primary text-white px-5"
          @click.prevent="PrintReport"
        >
          حفظ الوثيقة
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-8 m-auto">
      <vue-pdf-app
        :config="pdfConfig"
        @pages-rendered="pdfPagesRendered"
        style="height: 100vh;"
        :pdf="docUrl"
      ></vue-pdf-app>
    </div>
  </div>
</div>
